import { vmiAddProductModalStyles as styles } from "@hardware/Overrides/Components/VmiAddProductModal";
import { css } from "styled-components";

styles.bagQtyGridItem = {
    width: [3, 3, 2, 2, 2],
    css: css`
        margin-left: auto !important;
    `,
};
